import { useDispatch, useSelector } from "react-redux"
import ModalCustom from "."
import { RootState } from "stores/configureStore"
import { ReactComponent as IconWarning } from "assets/images/icons/icon-form-warning.svg"
import Button from "components/Button/Button"
import { incrementReloadVersionDeploy } from "reducers/version-deploy"
import { REACT_APP_API_VERSION } from "config/environments"

export const WarningVersionDeploy = () => {
  const dispatch = useDispatch()
  const { showVersionModal, serverVersion, reloadNow } = useSelector(
    (state: RootState) => state.versionDeploy
  )

  const handleReloadNow = () => {
    dispatch(incrementReloadVersionDeploy())
    window.location.reload()
  }
  if (!showVersionModal) return null

  const renderHeader = () => {
    return (
      <div className="flex items-center">
        <IconWarning />
        <p className="ml-[8px] text-[16px] text-[#222222] font-semibold">
          Update Available
        </p>
      </div>
    )
  }

  const renderBody = () => {
    return (
      <div className="flex flex-col">
        <p className="text-[14px] text-[#222222] leading-[24px]">
          Version: <strong>{`${REACT_APP_API_VERSION} Beta`}</strong>
        </p>
        <p className="text-[14px] text-[#222222] leading-[24px]">
          Build: <strong>{serverVersion}</strong>
        </p>
        {reloadNow ? (
          <p className="text-[14px] text-[#222222] leading-[24px] mt-[12px]">
            Something went wrong during the update. <br /> For further
            assistance, please contact the administrator.
          </p>
        ) : (
          <p className="text-[14px] text-[#222222] leading-[24px] mt-[12px]">
            A new version of the application has just been deployed. Please
            refresh the page to access the latest features and improvements.
          </p>
        )}
        {!reloadNow ? (
          <div className="mt-[32px]">
            <Button
              widthBtn={"100%"}
              onClick={handleReloadNow}
              title="Refresh now"
            />
          </div>
        ) : null}
      </div>
    )
  }
  return (
    <ModalCustom
      label="The application has been updated"
      widthModal={406}
      styleHeaderModal={{
        height: "auto",
        paddingTop: 12,
        alignItems: "start",
      }}
      renderHeader={renderHeader()}
      bodyChildren={renderBody()}
    />
  )
}
